<template>
  <nav
    class="sidebar"
    :class="{
      'sidebar--collapse': menuCollapse,
    }"
    @mouseleave="handleLeaveCollapse"
    @mouseenter="handleSetIsInSidebar"
  >
    <div class="sidebar__content">
      <div class="sidebar__main" @mouseenter="handleEnterSidebar(true)">
        <logo
          :app="owner_app"
          type="light"
          :size="sizeLogo"
          class="sidebar__logo"
        />
        <div class="sidebar__menu-content scrollbar_basic">
          <template v-for="menuItem in menuFormatted">
            <!--si es un submenu-->
            <template v-if="menuItem.menuItems">
              <sub-menu-item
                :title="menuItem.title"
                :show-title="menuCollapse"
                :key="menuItem._id"
                :active="isActiveSubMenu(menuItem.menuItems, menuItem._id)"
                @onSelected="selectSubMenu(menuItem._id)"
                :selected="
                  isActiveSubMenu(menuItem.menuItems, menuItem._id) && !idMenu
                    ? selectSubMenu(menuItem._id)
                    : idMenu === menuItem._id
                "
                width="inherit"
                :disabled="profileRemote ? true : false"
                :icon="menuItem.icon"
                :force-collapse="
                  isActiveSubMenu(menuItem.menuItems, menuItem._id) &&
                  menuCollapse
                "
                :is-new="menuItem.new"
              >
                <template slot="items">
                  <menu-item
                    v-for="item in menuItem.menuItems"
                    :key="item._id"
                    :icon="item.svg"
                    :show-title="menuCollapse"
                    :route="item.route"
                    :show-mark="false"
                    width="inherit"
                    @onSelected="selectMenu(item)"
                    :disabled="profileRemote ? true : false"
                    :is-new="menuItem.new"
                  >
                    <p slot="title" class="heading-h7 mrg-bottom-0 ellipsis">
                      {{ item.title }}
                    </p>
                  </menu-item>
                </template>
              </sub-menu-item>
            </template>
            <!--Si es un menu-->
            <menu-item
              v-else
              :key="menuItem._id"
              :title="menuItem.title"
              :icon="menuItem.svg"
              :show-title="menuCollapse"
              :route="menuItem.route"
              :badge="
                menuBadges.find((menu) => menu.route === menuItem.route) !==
                undefined
                  ? menuBadges.find((menu) => menu.route === menuItem.route)
                      .badge
                  : false
              "
              width="inherit"
              @onSelected="selectSubMenu(menuItem._id)"
              :disabled="profileRemote ? true : false"
              :is-new="menuItem.new"
            />
          </template>
        </div>
      </div>
      <div>
        <menu-notifications
          v-if="showMenuNotifications"
          :disabled="profileRemote ? true : false"
          :show-popup="showPopupFooter"
        />
        <menu-companies
          v-if="showMenuCompanies"
          :collapse="menuCollapse"
          :company-name="company.name"
          :disabled="profileRemote ? true : false"
          :show-popup="showPopupFooter"
        />
        <menu-footer
          v-if="profile && company && companyPricing"
          :collapse="menuCollapse"
          :names="fullname"
          :email="profile.email"
          :phone-number="phoneNumber"
          :avatar="profile.avatar"
          :company-name="company.name"
          :banner="company.banner"
          :disabled="profileRemote ? true : false"
          :show-popup="showPopupFooter"
          :type-user="transformTypeUser(profile.type, profile.subType || '')"
          :plan-name="namePlan"
        />
      </div>
    </div>
    <div
      :class="{
        'sidebar-button--active': menuCollapse,
        'sidebar-button--inactive': !menuCollapse,
      }"
      @click="handleClickButton(!menuCollapse)"
    ></div>
  </nav>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Logo from '@/app/shared/components/logos/Logo.vue'
import MenuItem from '@/app/commons/components/molecules/MenuItem'
import SubMenuItem from '@/app/commons/components/molecules/SubMenuItem'
import MenuFooter from '@/app/commons/components/organisms/MenuFooter'
import MenuNotifications from '@/app/commons/components/organisms/MenuNotifications'
import compareMixin from '@/app/shared/mixins/compare'
import attemptMixin from '@/app/shared/mixins/attempt'
import transformMixin from '@/app/shared/mixins/transform'
import MenuCompanies from '@/app/commons/components/organisms/MenuCompanies'
import moment from 'moment'

const iconUsers =
  '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20.9059 18.0938H19.0309V16.2188C19.0309 16.1157 18.9465 16.0313 18.8434 16.0313H17.7184C17.6153 16.0313 17.5309 16.1157 17.5309 16.2188V18.0938H15.6559C15.5528 18.0938 15.4684 18.1782 15.4684 18.2813V19.4063C15.4684 19.5094 15.5528 19.5938 15.6559 19.5938H17.5309V21.4688C17.5309 21.5719 17.6153 21.6563 17.7184 21.6563H18.8434C18.9465 21.6563 19.0309 21.5719 19.0309 21.4688V19.5938H20.9059C21.009 19.5938 21.0934 19.5094 21.0934 19.4063V18.2813C21.0934 18.1782 21.009 18.0938 20.9059 18.0938ZM8.75357 11.6813C8.73248 11.4774 8.72076 11.2712 8.72076 11.0626C8.72076 10.6899 8.75592 10.3266 8.82154 9.97272C8.83795 9.88834 8.79342 9.80162 8.71607 9.76647C8.39732 9.6235 8.10436 9.42662 7.85123 9.17819C7.55296 8.88899 7.31826 8.54078 7.16209 8.1558C7.00591 7.77082 6.93171 7.35751 6.9442 6.94225C6.96529 6.18991 7.26764 5.47506 7.79498 4.936C8.37389 4.34303 9.15201 4.01959 9.97935 4.02897C10.727 4.036 11.4489 4.32428 11.995 4.83522C12.1801 5.00866 12.3395 5.20084 12.4731 5.40709C12.52 5.47975 12.6114 5.51022 12.6911 5.48209C13.1036 5.33912 13.5395 5.23834 13.9872 5.19147C14.1184 5.17741 14.1934 5.03678 14.1348 4.91959C13.3731 3.41256 11.8169 2.37194 10.0169 2.34381C7.41998 2.30397 5.25436 4.43444 5.25436 7.03131C5.25436 8.50319 5.9317 9.81569 6.99342 10.6758C6.24811 11.0204 5.56139 11.4962 4.96607 12.0915C3.6817 13.3735 2.95514 15.0657 2.90826 16.8727C2.90764 16.8977 2.91202 16.9226 2.92117 16.9459C2.93031 16.9692 2.94402 16.9904 2.96149 17.0083C2.97897 17.0263 2.99985 17.0405 3.02291 17.0502C3.04597 17.0599 3.07074 17.0649 3.09576 17.0649H4.41061C4.51139 17.0649 4.59576 16.9852 4.59811 16.8844C4.64264 15.5251 5.19342 14.2524 6.16139 13.2868C6.85045 12.5977 7.6942 12.1196 8.61529 11.8876C8.70436 11.8618 8.76529 11.7751 8.75357 11.6813ZM19.3122 11.0626C19.3122 8.4985 17.252 6.41491 14.6973 6.37506C12.1004 6.33522 9.93717 8.46569 9.93717 11.0626C9.93717 12.5344 10.6169 13.8469 11.6762 14.7071C10.9232 15.0561 10.2377 15.5354 9.65123 16.1227C8.36686 17.4047 7.64029 19.0969 7.59342 20.9016C7.59279 20.9266 7.59718 20.9515 7.60632 20.9748C7.61546 20.9981 7.62918 21.0193 7.64665 21.0372C7.66412 21.0552 7.68501 21.0694 7.70807 21.0791C7.73112 21.0888 7.7559 21.0938 7.78092 21.0938H9.09342C9.1942 21.0938 9.27857 21.0141 9.28092 20.9133C9.32545 19.554 9.87623 18.2813 10.8442 17.3157C11.8544 16.3055 13.195 15.7501 14.6247 15.7501C17.2122 15.7501 19.3122 13.6524 19.3122 11.0626ZM16.7458 13.1837C16.1786 13.7508 15.4262 14.0626 14.6247 14.0626C13.8231 14.0626 13.0708 13.7508 12.5036 13.1837C12.2205 12.9021 11.9969 12.5666 11.8459 12.197C11.695 11.8274 11.6197 11.4313 11.6247 11.0321C11.6317 10.2633 11.9387 9.52037 12.4754 8.96959C13.0379 8.39303 13.7903 8.07194 14.5942 8.06256C15.3887 8.05553 16.1598 8.36491 16.727 8.92037C17.3083 9.48991 17.627 10.2516 17.627 11.0626C17.6247 11.8641 17.313 12.6165 16.7458 13.1837Z" /></svg>'
const iconPresentation =
  '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M21.1818 3H2.81818C1.81403 3 1 3.89543 1 5V19C1 20.1046 1.81403 21 2.81818 21H8H10H21.1818C22.186 21 23 20.1046 23 19V5C23 3.89543 22.186 3 21.1818 3ZM10 19H21V10H10V19ZM8 10H3V19H8V10ZM21 8H3V5H21V8Z" /></svg>'

export default {
  name: 'Sidebar',
  components: {
    Logo,
    MenuItem,
    SubMenuItem,
    MenuFooter,
    MenuNotifications,
    MenuCompanies,
  },
  data: () => ({
    moment,
    app: process.env.VUE_APP_NAME,
    owner_app: !process.env.VUE_APP_OWNER_APP
      ? process.env.VUE_APP_NAME
      : process.env.VUE_APP_OWNER_APP,
    width: 'max-content',
    idMenu: null,
    menuBadges: [],
    loopBadgeSchedules: null, // aun esta por ver
    rangeTimeSchedule: 5, // Rango de tiempo que se tomará en cuenta para notificar que hay agendas que atender
    message: '',
    description: '',
    valueNotification: false,
    allowCollapse: true, // permiso para colapsar
    readyToCollapse: false, // listo para colapsar
    showPopupFooter: true, // muestra o no el popup de footer menu
    isInSidebar: false, // si el cursor esta en el sidebar
  }),
  mixins: [compareMixin, attemptMixin, transformMixin],

  created() {
    this.handleExecuttedSetBadge(this.loggedIn)
  },
  watch: {
    loggedIn(val) {
      this.handleExecuttedSetBadge(val)
    },
    // cada vez que llegue un mensaje nuevo o se actualize mailbox esto se ejecuta solo para el menu de tickets
    mailboxes: {
      deep: true,
      handler() {
        if (this.profile && !this.isAllowedFor(this.profile.type, ['agent']))
          return
        /** Comprueba que hayan mensajes para setear en el badge de tickets */
        let total = this.mailboxes.reduce(
          (accumulator, currentValue) =>
            accumulator + currentValue.notifications,
          0
        )
        let menuTickets = this.menuBadges.find(
          (menu) => menu.route === 'workspace'
        )
        if (menuTickets !== undefined)
          menuTickets.badge = total > 0 ? true : false
      },
    },
    /**Cada vez que cambie el colapsado del sidebar, 300 es por la demora en la transicion */
    menuCollapse() {
      this.showPopupFooter = false
      setTimeout(() => {
        this.showPopupFooter = true
      }, 500)
    },
    /**Verifica el valor para realizar la accion de dejar el sidebar */
    isOpenSomePopupFooter() {
      if (!this.isInSidebar) this.handleLeaveCollapse()
    },
    /** Cada vez que se cambie el valor de un evento */
    schedules: {
      deep: true,
      handler() {
        this.calcBadgeSchedule()
      },
    },
  },
  computed: {
    ...mapGetters([
      'menuItems',
      'profile',
      'profileRemote',
      'company',
      'menuCollapse',
      'mailboxes',
      'schedules',
      'loggedIn',
      'isOpenSomePopupFooter',
      'companyPricing',
      'permissions',
      'enable_subspaces',
    ]),

    permissionsModule() {
      const name = 'general'
      return this.permissions[name]
    },
    /**
     * @returns {String} - tamaño del logo segun el collapse del sidebar
     */
    sizeLogo() {
      return this.menuCollapse ? 'medium' : 'small'
    },
    /**
     * Formateo de menu items
     * @returns {Array} - retorna menus deacuerdo al orden y se agrega los submenus
     */
    menuFormatted() {
      const firstSubmenu = {
        _id: 'first',
        title: 'Gestión de usuarios',
        menuItems: [],
        order: 2,
        icon: iconUsers,
      }
      const secondSubmenu = {
        _id: 'crm',
        title: 'CRM',
        menuItems: [],
        order: 9,
        icon: iconPresentation,
      }
      const menus = []
      this.menuItems.map((item) => {
        if (item.route === 'accounts' || item.route === 'queues') {
          firstSubmenu.menuItems.push(item)
        } else if (
          item.route === 'contacts' ||
          item.route === 'tickets' ||
          item.route === 'products'
        )
          secondSubmenu.menuItems.push(item)
        else menus.push(item)
      })
      if (firstSubmenu.menuItems.length > 0) menus.push(firstSubmenu)
      if (secondSubmenu.menuItems.length > 0) menus.push(secondSubmenu)
      return menus.sort((a, b) => a.order - b.order)
    },
    /**
     * Retorna el nombre y apellidos juntos
     * @returns {String} - nombre y apellidos juntos
     */
    fullname() {
      return this.profile
        ? `${this.profile.names} ${this.profile.surnames}`
        : ''
    },
    /**
     * Retorna el número de telefono y el codigo juntos
     * @returns {String} - número concatenado
     */
    phoneNumber() {
      let phoneNumber = ''
      if (this.profile) {
        if (this.profile.code) phoneNumber += `${this.profile.code} `
        if (this.profile.phone) phoneNumber += this.profile.phone
      }
      return phoneNumber
    },
    /**
     * Retorna el nombre del plan
     * @returns {String} - nombre del plan
     */
    namePlan() {
      if (!this.companyPricing) return ''
      return `Plan ${this.transformNamePlan(
        this.companyPricing.plan.key,
        'capitalize'
      )}`
    },
    /**
     * @return {Boolean} - mostrar menu de compañias
     */
    showMenuCompanies() {
      return (
        this.profile &&
        this.company &&
        this.companyPricing &&
        this.permissionsModule &&
        this.permissionsModule.show_menu_companies &&
        this.enable_subspaces
      )
    },
    /**
     * @return {Boolean} - mostrar menu de notificaciones
     */
    showMenuNotifications() {
      return (
        this.profile &&
        this.company &&
        this.permissionsModule &&
        this.permissionsModule.show_menu_notifications
      )
    },
  },
  methods: {
    ...mapActions(['selectMenu', 'setMenuCollapse']),
    /**
     * Cambia el valor de menuCollapse
     * @param {Boolean} collapse - valor de menu colapsado
     */
    handleChangeCollapse(collapse) {
      this.setMenuCollapse(collapse)
    },
    /**
     * Verifica si esta activo o no el submenu
     * @param {Array} menuItems1
     * @param {String} idSubmenu
     */
    isActiveSubMenu(menuItems1, idSubmenu) {
      let routeMenuItems = menuItems1.map((item) => item.route)
      if (idSubmenu === 'crm') {
        routeMenuItems = routeMenuItems.concat(['menu-products', 'menu-fields'])
      }
      if (routeMenuItems.includes(this.$route.name)) return true
      else return false
    },
    /**Selecciona y setea el valor del id del menu */
    selectSubMenu(id) {
      this.idMenu = id
      const menu = this.menuFormatted.find((menu) => menu._id === id)
      if (menu !== undefined) {
        if (!menu.menuItems) this.selectMenu(menu) // si no es un submenu
      }
    },
    /**
     * Setea si los menus del sidebar deberían tener el badge
     */
    setBadge() {
      this.executedSettedBadge = true
      const idMenuBadges = this.menuBadges.map((item) => item.route)
      for (let item of this.menuItems) {
        let total = 0
        switch (item.route) {
          case 'workspace': {
            total = this.mailboxes.reduce(
              (accumulator, currentValue) =>
                accumulator + currentValue.notifications,
              0
            )
            break
          }
          case 'calendar': {
            this.loopBadgeSchedules = this.setDoInterval(() => {
              total = this.calcBadgeSchedule()
            }, 60000)
            break
          }
        }
        if (!idMenuBadges.includes(item.route))
          this.menuBadges.push({
            route: item.route,
            badge: total > 0 ? true : false,
          })
      }
    },
    /**
     * Realiza el calculo para mostrar el badge y la notificación de la agenda
     */
    calcBadgeSchedule() {
      const schedule_route = 'calendar'
      let total = 0
      // Comprueba cada minuto si hay alguna agenda por vencer
      let dates = [...this.schedules]
        .filter(
          (schedule) =>
            !schedule.completed_at && // no deben estar completados
            schedule.scheduled_for && // verificar que tengan fecha de agenda
            moment(new Date()).isSame(schedule.scheduled_for, 'day') && // Debe ser del mismo día
            moment(new Date(schedule.scheduled_for)).isSameOrAfter(
              moment(new Date()),
              'minute'
            ) // La agenda no debe estar vencida
        )
        .map((schedule) => schedule.scheduled_for) // Solo la fecha

      total = this.isThereInXMin(this.rangeTimeSchedule, dates) // Comprueba que esté dentro del rango dentro de 5min
      let menuSchedule = this.menuBadges.find(
        (menu) => menu.route === schedule_route
      )
      if (menuSchedule !== undefined) {
        if (total > 0) {
          menuSchedule.badge = true
          if (this.valueNotification === false) {
            total === 1
              ? ((this.message = '1 agenda pendiente'),
                (this.description =
                  'En 5 minutos tu agenda vencerá, atiéndela a tiempo.'))
              : ((this.message = total + ' agendas por vencer'),
                (this.description =
                  'En 5 minutos tus agendas vencerán, atiéndelas a tiempo.'))

            this.openNotification(this.message, this.description)
          }
        } else {
          menuSchedule.badge = false
          this.valueNotification = false
        }
      }
      const scheduleMenu = this.menuBadges.find(
        (el) => el.route === schedule_route
      )
      if (scheduleMenu) scheduleMenu.badge = total > 0 ? true : false
      return total
    },
    /**
     * @param {String} message titulo se mostrará según cantidad de agendas vencidas
     * @param {String} description mensaje de descripcion agendas vencidas
     */
    openNotification(message, description) {
      this.valueNotification = true
      const key = `open${Date.now()}`
      this.$notification.open({
        message: message,
        description: description,
        icon: <a-icon type="alert" style="color: #FAAD14" />,
        duration: 0,
        btn: (h) => {
          return h(
            'a-button',
            {
              props: {
                type: 'primary',
                size: 'small',
              },
              on: {
                click: () => this.$notification.close(key),
              },
            },
            'Aceptar'
          )
        },
        key,
        onClose: close,
      })
    },
    /**
     * Limpia los valores usados en el interval
     */
    cleanData() {
      this.loopBadgeSchedules = null
      this.menuBadges = []
    },
    /**
     * Evento ejecutado cuando se entra al sidebar__logo
     * @param {Boolean} collapse - valor de menu colapsado
     */
    handleEnterSidebar(collapse) {
      this.readyToCollapse = true
      setTimeout(() => {
        if (this.readyToCollapse) {
          this.handleChangeCollapse(collapse)
        }
      }, 150)
    },
    /**
     * Limpia los datos seteados mientras el sidebar esta colapsado
     */
    handleLeaveCollapse() {
      this.isInSidebar = false

      if (
        this.allowCollapse &&
        this.readyToCollapse &&
        !this.isOpenSomePopupFooter
      ) {
        this.idMenu = null
        this.handleChangeCollapse(false)
        this.readyToCollapse = false
      }
    },
    /**
     * Escucha el evento del boton de collapsado
     * @param {Boolean} collapse - valor de menu colapsado
     */
    handleClickButton(collapse) {
      this.allowCollapse = !this.allowCollapse
      this.handleChangeCollapse(collapse)
    },
    /**
     * Setea verdadero si esta dentro del sidebar o false si esta fuera
     */
    handleSetIsInSidebar() {
      this.isInSidebar = true
    },
    /**
     * Se ejecuta para correr la funcion de seteo
     * @param {Boolean} isLogged - valor de si esta logueado o no
     */
    handleExecuttedSetBadge(islogged) {
      if (islogged) {
        this.intervalPromiseAttempt(() => {
          if (!this.profile || !this.menuItems || this.menuItems.length === 0)
            throw 'profile & items'
          this.setBadge()
        })
      } else {
        clearInterval(this.loopBadgeSchedules)
        this.cleanData()
      }
    },
  },
}
</script>

<style lang="sass" scoped>
.sidebar
  background-color: $gray_dark_900
  width: 58px
  height: 100vh
  position: fixed
  left: 0
  z-index: 1002
  transition: width 0.3s
  &__logo
    margin: 20px 0px 17px
    height: 30px
  &__content
    height: 100%
    display: flex
    flex-direction: column
    justify-content: space-between
  &__main
    padding-left: 0px
    overflow: hidden
    flex-grow: 1
    display: flex
    flex-direction: column
  &__menu-content
      padding-left: 0px
      overflow-y: scroll
      flex-grow: 1
  &--collapse
    width: 224px
    transition: width 0.3s
    .sidebar-button--active
      &::before
        transform: rotate(25deg) translate3d(0px, 1px, 0px)
        transition: transform 0s 0.3s
      &::after
        transform: rotate(-25deg) translate3d(0px, -1px, 0px)
        transition: transform 0s 0.3s
  &__footer
    position: relative
  &__popover
    position: absolute
  &-button
    &--active
      position: absolute
      right: -21px
      top: 50%
      height: 50px
      margin-top: -25px
      cursor: pointer
      padding: 15px
      &::before
        display: flex
        content: ""
        width: 2px
        height: 10px
        background-color: $gray_dark_900
        transition: transform 0.3s ease 0s
      &::after
        display: flex
        content: ""
        width: 2px
        height: 10px
        background-color: $gray_dark_900
        transition: transform 0.3s ease 0s
      &:hover::before
        transform: rotate(25deg) translate3d(0px, 1px, 0px)
      &:hover::after
        transform: rotate(-25deg) translate3d(0px, -1px, 0px)
    &--inactive
      position: absolute
      right: -21px
      top: 50%
      height: 50px
      margin-top: -25px
      cursor: pointer
      padding: 15px
      &::before
        display: flex
        content: ""
        width: 2px
        height: 10px
        background-color: $gray_dark_900
        transition: transform 0.3s ease 0.3s
        transform: rotate(-25deg) translate3d(0px, 1px, 0px)
      &::after
        display: flex
        content: ""
        width: 2px
        height: 10px
        background-color: $gray_dark_900
        transition: transform 0.3s ease 0.3s
        transform: rotate(25deg) translate3d(0px, -1px, 0px)
</style>
